import { ca } from '@cian/analytics';

import { IProduct } from '../../../types/analytics';

interface ITrackPhoneButtonClickParams {
  label: string;
  product: IProduct;
}

export function trackPhoneButtonClick({ label, product }: ITrackPhoneButtonClickParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_listing',
    label,
    products: [product],
  });
}
